import classnames from 'classnames'
import React from 'react'
import './pencil.css'

export const Pencil: React.SFC<React.HTMLAttributes<SVGElement>> = ({className, ...props}) => <svg xmlns="http://www.w3.org/2000/svg" {...props} className={classnames(className, 'icon-pencil')} viewBox="0 0 26 26">
  <path d="M0 0h26v26H0z" opacity=".25"/>
  <path d="M6.547 16.919v2.924h2.924l8.464-8.541-2.924-2.924zm13.619-7.848a.744.744 0 0 0 0-1.077l-1.77-1.77a.744.744 0 0 0-1.077 0l-1.385 1.385 2.924 2.924z" fill="#fff"/>
</svg>
